"use client";
import * as m from "motion/react-m";
import { useTranslations } from "next-intl";

import { useSoundboard } from "../state/reducer";
import { CreateAccountButton } from "./CreateAccountReusableButton";
import { ShareButton } from "./ShareButton";

export const CreateAccountCta = () => {
  const t = useTranslations("ClientKeys.soundboard.create_account_cta");
  const { state } = useSoundboard();

  // User state is not loaded yet
  if (state.user === undefined) {
    return null;
  }

  return (
    <m.div
      animate={{ opacity: 1 }}
      className='flex flex-col gap-8'
      initial={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {state.user ? (
        <ShareButton />
      ) : (
        <>
          <p className='font-soundboard f-ui-04 normal-case text-lightest'>{t("description")}</p>
          <CreateAccountButton state={state}>{t("label")}</CreateAccountButton>
        </>
      )}
    </m.div>
  );
};
